import { render, staticRenderFns } from "./FormEventsIncident.vue?vue&type=template&id=36626356&"
import script from "./FormEventsIncident.vue?vue&type=script&lang=js&"
export * from "./FormEventsIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QBanner});
